__webpack_require__.p = "/my-web-apps/react/semantic_ui_react_trivial/";